
/*Package importing*/
import React, { Component } from 'react';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import NothingFound from '../../components/common/nothingFound';
import GroupedBarChart from '../../components/charts/groupedBar';
import APILoader from '../../components/other/api-loader';


/*Assets*/
import profile from '../../assets/images/profile.png';
import profPlaceholder from '../../assets/images/profile-placeholder.jpg';

/*Services*/
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';
import APIPost from '../../services/apiCall/post';

class Dashboard extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: [],
      apiLoading: false,
      filter: null,
      commissionData: null,
      commissionFilter: 1,
      filterOneDefault: { value: 1, label: 'Last 1 week' },

    }
  }

   componentDidMount() {
    this.getData();
    this.getCommission(this.state.commissionFilter);
  }

  getData(){
    // this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'dashboard/detail';
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        this.setState({ data: response.data});
      }
    }.bind(this))
  }
  getCommission(tempFilter){
    var url = devconfig.vendor +'dashboard/visitors-chart';
    var data = JSON.stringify({
      "date_filter" : tempFilter
    });
    APIPost(url,data).then(function(response){
      if(response.status){
        this.setState({commissionData: response.graph_data});
      }
    }.bind(this))
  }
  dateFilterChangeOne = async (filter) => {
    await this.setState({commissionFilter: filter.value, commissionData: null});
    this.getCommission(filter.value);
  }

  render() {
    const filterBy1 = [
      { value: 1, label: 'Last 1 week' },
      { value: 2, label: 'Last 1 month' },
      { value: 3, label: 'Last 3 months' },
    ]
    return (
      <div className="e-main-content e-driver-detail-wrap e-dash-wrap">
        <h2 className="e-page-head">Dashboard</h2>
        <div className="row">
          <div className="col-lg-9">
            <div className="row">
              <div className="col-lg-3">
                <div className="e-summry-card-wrap">
                  <h6>{this.state.data.total_ads_clicks}</h6>
                  <p className="mb-0">Total Ads Clicks</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="e-summry-card-wrap">
                  <h6>{this.state.data.total_ads_posted}</h6>
                  <p className="mb-0">Total Ads Posted</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="e-summry-card-wrap">
                  <h6>{this.state.data.total_ads_views}</h6>
                  <p className="mb-0">Total Ads Views</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="e-summry-card-wrap">
                  <h6>{this.state.data.total_amount_spent}</h6>
                  <p className="mb-0">Total Amount Spent</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-5">

          <div className="col-lg-6">
            <div className="row mb-4">
              <div className="col-lg-8">
                <h2>Visitors & Ad's clicked</h2>
              </div>
              <div className="col-lg-4">
                <div className="e-filter-wrap">
                  <SelectBox defaultValue={this.state.filterOneDefault} isSearchable={false} options={filterBy1} selectchange={this.dateFilterChangeOne} placeholder="Filter"/>
                </div>
              </div>
            </div>
            {
              this.state.commissionData ?
                <GroupedBarChart data={this.state.commissionData} type={this.state.commissionFilter}/>
              :
                <div className="text-center mt-5 pt-5">
                  <APILoader/>
                </div>
            }
          </div>
        </div>
      </div>

    );
  }
}

export default Dashboard;
